var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('a',{staticClass:"mb-0",attrs:{"href":_vm.streamConfigHref}},[_vm._v(" "+_vm._s(_vm.channel.name)+" ")])]),_c('div',{staticClass:"col"},[_vm._v(" "+_vm._s(_vm.stream.sep_state)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }